import { useMemo } from 'react';
import { useGlobalForgeApps } from '@atlassian/jira-atlassian-navigation/src/controllers/addons/forge/index.tsx';
import type { GlobalPage } from '@atlassian/jira-forge-ui-types/src/common/types/extension.tsx';
import { toSections } from '@atlassian/jira-navigation-apps-sidebar-forge/src/common/utils/subpages/index.tsx';
import { useMatchedExtension } from '@atlassian/jira-spa-apps-forge-common/src/controllers/index.tsx';
import { useRouter } from '@atlassian/react-resource-router';

export const useForgeGlobalPageItems = () => {
	const [{ match }] = useRouter();
	const { data: modules, loading, error } = useGlobalForgeApps();
	const extension = useMatchedExtension<GlobalPage>({ modules, match });

	const sections = useMemo(() => extension && toSections(extension), [extension]);

	return { extension, sections, loading, error };
};
